import React, { ReactElement, createRef, useState } from "react"
import Slider from "react-animated-slider"
import classnames from "classnames"

import SlideshowNext from "../../images/slideshow-next.inline.svg"
import SlideshowPrev from "../../images/slideshow-prev.inline.svg"

import { ProductHeader } from "./product-header"

import { isPropEqTo } from "../../utility"

import * as styles from "./slider.module.css"
import "./slider.css"

const isMdxTypeEqToTouchpointDescription = (object: any) =>
  isPropEqTo(object, "mdxType", "TouchpointDescription")

const isMdxTypeEqToCollectorDescription = (object: any) =>
  isPropEqTo(object, "mdxType", "CollectorDescription")

const isMdxTypeEqToQuestion = (object: any) =>
  isPropEqTo(object, "mdxType", "Question")

export const Slideshow = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.SlideShowContainer}>
    <div className={styles.TouchpointDescription}>
      {Array.isArray(children) &&
        children.find(isMdxTypeEqToTouchpointDescription)}
    </div>
    <Slider
      classNames={{ buttonDisabled: styles.disabledButton }}
      duration={200}
      previousButton={<SlideshowPrev />}
      nextButton={<SlideshowNext />}
      onSlideChange={(e: any) => {
        document
          .querySelector(".slide.previous .fancy-scroll")
          ?.scrollTo({ top: 0 })
        document
          .querySelector(".slide.next .fancy-scroll")
          ?.scrollTo({ top: 0 })
      }}
    >
      {Array.isArray(children) ? (
        children
          .filter(x => !isMdxTypeEqToTouchpointDescription(x))
          .map((k, i) => <div key={i}> {k}</div>)
      ) : (
        <div>{children}</div>
      )}
    </Slider>
  </div>
)

export const SliderItem = ({ image = "", children }: any) => {
  const [isLearnmoreShown, setLearnmoreShow] = useState(false)

  const sliderRef = createRef<HTMLDivElement>()
  const contentContainerRef = createRef<HTMLDivElement>()

  const scrollToLearnMore = () => {
    setLearnmoreShow(true)
    sliderRef?.current?.scrollTo({
      top: contentContainerRef?.current?.clientHeight,
      behavior: "smooth",
    })
  }

  const CollectorDescription = children.find(isMdxTypeEqToCollectorDescription)
  const Question = children.find(isMdxTypeEqToQuestion)

  const QuestionName = Question?.props?.name.toUpperCase()

  const hasLearnMore = CollectorDescription && Question

  return (
    <>
      <div
        ref={sliderRef}
        className={classnames(styles.slider, "fancy-scroll")}
        style={{ overflow: isLearnmoreShown ? "auto" : "hidden" }}
      >
        <div ref={contentContainerRef} className={styles.contentContainer}>
          {hasLearnMore && !isLearnmoreShown && (
            <div onClick={scrollToLearnMore} className={styles.learnMoreLink}>
              (learn more)
            </div>
          )}
          <div className={styles.image}>
            {typeof image === "string" ? <img src={image} /> : image()}
          </div>
        </div>
        <div
          className={classnames(
            styles.learnMoreContainer,
            isLearnmoreShown ? styles.learnMoreShown : ""
          )}
        >
          <div>{CollectorDescription}</div>
          <div>
            <ProductHeader color="#00A98F" title={QuestionName} />
            {Question}
          </div>
        </div>
      </div>
    </>
  )
}

export const SliderItemContent = ({ children }: { children: ReactElement }) => (
  <div className={styles.sliderItemContent}>{children}</div>
)
